import { NgModule } from '@angular/core';

import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

import {
    ExpandableComponent,
    HighlightTextPipe,
    HorizontallerComponent,
    HorizontallerHeaderDirective,
    HorizontallerItemComponent,
    LoaderComponent,
    LoadingSlateComponent,
    PrologueComponent,
    SeparatorComponent,
    SpinnerComponent,
} from '@exl-ng/mulo-common';
import {
    CenteredBlockLayoutComponent,
    FeaturedTileComponent,
} from '@exl-ng/mulo-views';

import { SharedModule } from '../shared/shared.module';

import { ResearchUnitsRoutingModule } from './research-units-routing.module';
import { ResearchUnitsComponent } from './research-units.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ResearchUnitHomepageComponent } from './research-unit-homepage/research-unit-homepage.component';
import { AdvancedSearchModule } from '../parts/advanced-search/advanced-search.module';
import { ResearchUnitNavComponent } from './research-unit-nav/research-unit-nav.component';
import { ObserversModule } from '@angular/cdk/observers';
import { MatRippleModule } from '@angular/material/core';
import { ResearchUnitHeaderComponent } from './research-unit-header/research-unit-header.component';
import { ResearchUnitMetricsComponent } from './research-unit-metrics/research-unit-metrics.component';
import { PortalModule } from '../portal/portal.module';
import { DeferLoadModule } from '@trademe/ng-defer-load';
import { ResearchUnitCollectionsComponent } from './research-unit-collections/research-unit-collections.component';

@NgModule({
    imports: [
        SharedModule,
        ResearchUnitsRoutingModule,
        CenteredBlockLayoutComponent,
        MatTreeModule,
        MatButtonModule,
        MatIconModule,
        PrologueComponent,
        MatTabsModule,
        MatDatepickerModule,
        MatInputModule,
        ReactiveFormsModule,
        HighlightTextPipe,
        MatFormFieldModule,
        MatIconModule,
        SeparatorComponent,
        AdvancedSearchModule,
        ObserversModule,
        MatRippleModule,
        ExpandableComponent,
        LoadingSlateComponent,
        SpinnerComponent,
        LoaderComponent,
        PortalModule,
        DeferLoadModule,
        FeaturedTileComponent,
        HorizontallerComponent,
        HorizontallerHeaderDirective,
        HorizontallerItemComponent,
        ResearchUnitsComponent,
        ResearchUnitHomepageComponent,
        ResearchUnitNavComponent,
        ResearchUnitHeaderComponent,
        ResearchUnitMetricsComponent,
        ResearchUnitCollectionsComponent,
    ],
    exports: [ResearchUnitNavComponent, ResearchUnitHeaderComponent],
})
export class ResearchUnitsModule {}
